import { useLocation } from 'react-router-dom';
import TabLink from './TabLink';

const Tabs = ({ tabs }) => {
    const location = useLocation();

    return (
        // <div style={{ display: 'flex', borderBottom: '1px solid #ccc', borderTop: '1px solid #ccc', marginTop: '4px' }}>
        //     {tabs.map((x) => (
        //         <TabLink to={x.to} active={location.pathname === x.to}>
        //             {x.title}
        //         </TabLink>
        //     ))}
        // </div>
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'space-around',
                borderBottom: '1px solid #ccc',
                borderTop: '1px solid #ccc',
                marginTop: '8px',
            }}
        >
            {tabs.map((x) => (
                <TabLink
                    to={x.to}
                    active={location.pathname === x.to}
                    style={{
                        padding: '8px 16px',
                        textDecoration: 'none',
                        cursor: 'pointer',
                        backgroundColor: location.pathname === x.to ? '#333' : 'transparent',
                        color: location.pathname === x.to ? '#fff' : '#555',
                        fontWeight: location.pathname === x.to ? 'bold' : 'normal',
                        borderBottom: location.pathname === x.to ? '2px solid #007BFF' : 'none',
                        transition: 'background-color 0.3s, color 0.3s',
                        
                    }}
                >
                    {x.title}
                </TabLink>
            ))}
        </div>
    );
};

export default Tabs;
